import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { api } from "../lib/api";
import { AdminLogin } from "../components/admin/AdminLogin";
import { AdminShell } from "../components/admin/AdminShell";

export default function Admin() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    let alive = true;
    document.title = "SYNrise — Admin";
    const robots = document.createElement("meta");
    robots.name = "robots";
    robots.content = "noindex, nofollow";
    document.head.appendChild(robots);
    api.get("/auth/me").then((r) => alive && setUser(r.data)).catch(() => alive && setUser(false));
    return () => { alive = false; robots.remove(); };
  }, []);

  if (user === null) {
    return <div className="flex min-h-[100svh] items-center justify-center" data-testid="admin-loading"><Loader2 className="h-6 w-6 animate-spin text-gold" /></div>;
  }
  return user ? <AdminShell me={user} onLogout={() => setUser(false)} /> : <AdminLogin onLogin={setUser} />;
}
